import React from 'react';
import StoryMenu from './StoryMenu';

const StoriesMain = () => {
    return <StoryMenu />;
};

export default StoriesMain; 